import React from "react";
import styles from "./Footer.module.css"

const Footer = () => {
  return (
    <>
    <div className={styles.footer_container}>
    <div className={styles.footer}>
      <p> Musicart | All rights reserved</p>
      </div>
      </div>
    </>
  );
};

export default Footer;
